import invert from 'lodash/invert';

export const THUMBPRINT_RADIO_MUSIC_ID = 'TT0';
export const typeToMusicIdPrefix = {
  track: 'S',
  artist: 'R',
  composer: 'C',
  genre: 'G',
  advertiser: 'A',
  artistStation: 'T', // Now the "Featured" stations
  thumbprint: 'P', // There is no "P" code on the server end, added here for client side filtering & ordering.
} as const;
export const musicIdPrefixToType = invert(typeToMusicIdPrefix);
